import React from "react";
import classNames from "classnames";
import {ReactComponent as Error} from "../../images/monochrome-icons/ic-error.svg";
import {ReactComponent as Warning} from "../../images/monochrome-icons/ic-warning.svg";
import {ReactComponent as Success} from "../../images/monochrome-icons/ic-success-circle.svg";
import typography from "../typography.module.scss";
import styles from "./InlineNotification.module.scss";

const iconTypeMapper = {
    error: { icon: Error },
    warning: { icon: Warning },
    success: { icon: Success },
    info: { icon: Warning }
};

export default ({children, type, className, style, bold, unicolor, prefix, ...rest}) => {
    const Icon = iconTypeMapper[type].icon;
    return (
        <div className={classNames(typography.body14, styles["container"], styles[type], className, {[styles["bold"]]: bold, [styles["unicolor"]]: unicolor})} style={style} {...rest}>
            <Icon className={styles["type-icon"]}/>
            <div>{prefix && <span className={styles['prefix']}>{prefix}: </span>}{children}</div>
        </div>
    );
};
